import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6aa131ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = { name: "crypto-plan-card" };
const _hoisted_2 = { class: "crypto-name" };
const _hoisted_3 = {
    key: 0,
    class: "crypto-is"
};
import CryptoIcon from '@/materials/atoms/CryptoIcon.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        cryptoName: null,
        interestRate: null
    },
    setup(__props) {
        const props = __props;
        const { CHOICECARD, format } = useMessage();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(CryptoIcon, {
                    class: "crypto_icon",
                    base: props.cryptoName.toLowerCase(),
                    width: 50
                }, null, 8, ["base"]),
                _createElementVNode("span", _hoisted_2, _toDisplayString(props.cryptoName.toUpperCase()), 1),
                (props.interestRate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(format)(_unref(CHOICECARD).CARD)) + " " + _toDisplayString(props.interestRate) + "%", 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
